import Blockly from 'blockly/browser'
import Util, { defineBlock, defineStmtBlock } from '../Util'
import Mutators from '../Mutators'

defineBlock(
  'javascript_lambda_declaration',
  {
    message0: 'fn ( %1 ) %2 %3',
    args0: [
      {
        type: 'field_input',
        name: 'arguments',
        text: ''
      },
      {
        type: 'input_dummy'
      },
      {
        type: 'input_statement',
        name: 'body'
      }
    ],
    output: null,
    tooltip: 'Declare a function as a value',
    colour: Blockly.Msg.PROCEDURES_HUE
  },
  function(block) {
    var argumentsText = block.getFieldValue('arguments')
    var statementBody = Blockly.JavaScript.statementToCode(block, 'body')
    var code = `function(${argumentsText}) {${statementBody ? `\n${statementBody}` : ''}}`
    return [code, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'javascript_function_declaration',
  {
    message0: 'declare function %1 ( %2 ) %3 %4',
    args0: [
      {
        type: 'field_input',
        name: 'NAME',
        text: ''
      },
      {
        type: 'field_input',
        name: 'arguments',
        text: ''
      },
      {
        type: 'input_dummy'
      },
      {
        type: 'input_statement',
        name: 'body'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Declares named function with comma separated arguments in the current scope',
    colour: Blockly.Msg.PROCEDURES_HUE
  },
  function(block) {
    const name = block.getFieldValue('NAME') || 'unnamed'
    const args = block.getFieldValue('arguments') || ''
    const body = Blockly.JavaScript.statementToCode(block, 'body')
    return `\nfunction ${name}(${args}) {${body ? `\n${body}` : ''}}\n`
  }
)

function getArgumentsCode(argCount, block) {
  const argStrings = []
  for (let i = 0; i < argCount; i++) {
    argStrings.push(
      `${Blockly.JavaScript.valueToCode(block, 'ITEM' + i, Blockly.JavaScript.ORDER_ATOMIC) ||
        'null'}`
    )
  }
  return `${argStrings.join(', ')}`
}

function getPropSafely(obj, ...props) {
  if (props && props.length === 0) return obj
  const p = props && props.length > 0 && props[0]
  if (!obj || !p || !obj[p]) return null
  props[0] = obj[p]
  return getPropSafely.apply(null, props)
}

function getFunctionCodifier(isStatement) {
  return function functionInvocationBlockToCode(block) {
    const argumentsString = getArgumentsCode(this.count, block)
    let functionCode =
      Blockly.JavaScript.valueToCode(block, 'function', Blockly.JavaScript.ORDER_ATOMIC) ||
      '(function() {})'
    const targetFunctionConnection = getPropSafely(
      block.getInput('function'),
      'connection',
      'targetConnection'
    )
    if (
      targetFunctionConnection &&
      targetFunctionConnection.getSourceBlock() &&
      targetFunctionConnection.getSourceBlock().type === 'javascript_lambda_declaration'
    ) {
      functionCode = `(${functionCode})`
    }
    const invocationCode = `${functionCode}(${argumentsString})`
    return isStatement
      ? invocationCode + ';\n'
      : [invocationCode, Blockly.JavaScript.ORDER_FUNCTION_CALL]
  }
}

// Set up a mutator for the function invocation blocks for setting up argument inputs dynamically
Mutators.registerCountMutator('javascript_argument_count_mutator', 'arg', 'arguments')

defineBlock(
  'javascript_function_invocation',
  {
    message0: 'invoke %1',
    args0: [
      {
        type: 'input_value',
        name: 'function'
      }
    ],
    previousStatement: null,
    nextStatement: null,
    tooltip: 'Invokes a function',
    mutator: 'javascript_argument_count_mutator',
    colour: Blockly.Msg.PROCEDURES_HUE
  },
  getFunctionCodifier(true)
)

defineBlock(
  'javascript_function_invocation_return',
  {
    message0: 'invoke %1',
    args0: [
      {
        type: 'input_value',
        name: 'function'
      }
    ],
    output: null,
    tooltip: 'Invokes a function with output',
    mutator: 'javascript_argument_count_mutator',
    colour: Blockly.Msg.PROCEDURES_HUE
  },
  getFunctionCodifier(false)
)

defineBlock(
  'javascript_function_return',
  {
    message0: 'return result %1',
    args0: [
      {
        type: 'input_value',
        name: 'VALUE'
      }
    ],
    previousStatement: null,
    tooltip: 'Returns the result from a function',
    colour: Blockly.Msg.PROCEDURES_HUE
  },
  function(block) {
    const value =
      Blockly.JavaScript.valueToCode(block, 'VALUE', Blockly.JavaScript.ORDER_ATOMIC) || null
    return `return${value != null ? ` ${value}` : ''};\n`
  }
)

defineBlock(
  'javascript_object_new',
  {
    message0: 'a new %1',
    args0: [
      {
        type: 'input_value',
        name: 'function'
      }
    ],
    output: null,
    tooltip: 'Constructs a new object from a constructor function',
    colour: Util.colors.objects,
    mutator: 'javascript_argument_count_mutator'
  },
  function(block) {
    const helper = getFunctionCodifier(false)
    const [code, order] = helper.apply(this, [block])
    return [`new ${code}`, order]
  }
)
